import styled from "styled-components";
import { GenericContainer } from "../../GlobalStyles";

export const PriceWrapper = styled.div`
    background: transparent;
    text-align: left;
    max-width: 100%;
    margin: auto;
`;

export const Pad = styled.div`
    padding: 1.5rem;
`;

export const PriceImage = styled.img`
    width: 100%;
    height: 384px;
    object-fit: cover;
    object-position: top;
    margin-bottom: 3rem;

    @media (max-width: 1220px){
        max-height: 225px;
        margin-bottom: 1rem;
    }
    
    opacity: 0.9;
`;

export const PriceTitle = styled.h1`
    color: #fff;
    font-weight: 400;
    font-size: 32px;    
    margin-bottom: 2rem;

    @media (max-width: 900px){
        font-size: 24px;
        margin-bottom: 1rem;
    }
`;

export const Price = styled.p`
    color: #F6BF2F;
    font-size: 38px;
    font-weight: 400;
    width: 100%;
    border-bottom: 2px dashed #363739;

    &:before{
        content: '$'
    }
    
    padding-bottom: 1.5rem;
    margin-bottom: 3rem;

    @media (max-width: 900px){
        margin-bottom: 1rem;
        font-size: 28px;
    }
`;

export const PriceContent = styled.p`
    max-width: 100%;
    text-align: right;
    margin: 0 auto 0 0;
    color: #a8a8a8;
    font-size: 16px;
    line-height: 29px;
    white-space: pre-wrap;
    word-break: break-word;
    text-align: left;
    margin-bottom: 3rem;

    @media (max-width: 900px){
        margin-bottom: 1rem;
    }
`;

export const PriceButton = styled.a`
    max-width: 100%;
    outline: none;
    color: #fff;
    border: 2px solid #F6BF2F;
    margin-right: autoo;
    padding: 10px 30px;
    text-transform: uppercase;
    background: transparent;
    text-decoration: none;

    cursor: pointer;

    &:hover{
        background: #F0B83D;
        color: #fff;
    }
`;

export const PrevArrow = styled.div`
    width: 61px;
    height: 61px;
    z-index: 99999;
    background: transparent;
    border-radius: 50% !important;
    position: absolute;
    top: calc(50% - 15px);
    left: -80px;
    cursor: pointer;
`;

export const NextArrow = styled.div`
    width: 61px;
    height: 61px;
    z-index: 99999;
    background: transparent;
    border-radius: 50% !important;
    position: absolute;
    top: calc(50% - 15px);
    right: -80px;
    cursor: pointer;
`;

export const PriceHeader = styled.div`
    position: relative;
    width: 100%;
    height: auto;
    padding: 1rem 0rem 1rem 6rem;
    background: linear-gradient( -45deg,transparent 52%,#D9A638 52%,#D9A638 56%,#0D0E12 56%);
    font-weight: bold;
    font-size: 48px;
    text-transform: uppercase;
    color: #E7E7E8;
    text-align: left;
    box-sizing: border-box;
    margin-top: 5rem;

    @media (max-width: 1224px){
        background: transparent;
        text-align: center;
        padding: 1rem;
    }
    
    @media (max-width: 700px){
        margin-top: 0;
        font-size: 32px;
        margin-bottom: 0;
        text-align: left;
    }

`;

export const PricePic = styled.img`
    z-index: -1;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    object-position: bottom;
    object-fit: cover;
`;

export const PriceOverlay = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    background: linear-gradient(to bottom,rgba(24,27,29, 0.7) 50%, #131518 100%);
`;

